import app from '../angular_app.es6';

app.directive('stdHeatmaps', [ '$rootScope', '$timeout', 'MarkupTool', ($rootScope, $timeout, MarkupTool) => {
  return {
    restrict: 'E',
    scope: {
      imageUrl: "=",
      comments: "=",
      reaction: "=",
      setTopStyle: "@"
    },
    template: require('./std_heatmaps_template.html'),

    link: ($scope, $element) => {
      const filter = {};
      filter[$scope.reaction] = true;

      $scope.mtData = new MarkupTool([], filter, [], null, null, 'area_and_text');

      $scope.$watch('comments', (newValue) => {
        $scope.mtData.setAllComments(newValue);
        $scope.$broadcast('collectionChanged');
      });
    }
  };
} ]);


